export const URL = `${process.env.REACT_APP_API_URL}`;

export const RECRUIMENTS_NEW = 4;
export const RECRUIMENTS_LIST = 12;
export const RECRUIMENTS_RELATIVE = 12;